<template>
  <v-card class="align-stretch" height="100%" :loading="getIsTelcoProvisioningLoading">

    <v-card-title>
      Provisioning     
      <BeehiveIcon :link="articleLinks.provisioningTelco" />

      <v-spacer></v-spacer>

      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" color="secondary" x-small @click="sendApptReminder" :disabled="getIsSendApptReminderLoading" :loading="getIsSendApptReminderLoading"><v-icon small>{{emailIcon}}</v-icon></v-btn>
        </template>
        <span>Send appointment reminder</span>
      </v-tooltip>

      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" color="secondary" class="ml-2" x-small :href="queueUrl" target="_blank"><v-icon small>{{queueIcon}}</v-icon></v-btn>
        </template>
        <span>Provisioning Queue</span>
      </v-tooltip>

      <v-btn color="secondary" class="ml-2" x-small @click="editProvisioning=true;"><v-icon small>edit</v-icon></v-btn>

    </v-card-title>

    <v-card-text>

      <v-row>
        <v-col cols="12" md="6">
          <p class="mb-1 text-caption">Order Type</p>
          <p class="display-1 accent--text">{{getTelcoProvisioning.order_type | customPlaceholder}}</p>
        </v-col>

        <v-col cols="12" md="6">
          <p class="mb-1 text-caption">Expected Live Date</p>
          <p class="display-1 accent--text">{{getTelcoProvisioning.expected_live_date | formatCustomDate('YYYY-MM-DD')}}</p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <p class="mb-1 text-caption">Broadband Supplier</p>
          <p><b>{{getTelcoProvisioning.broadband_supplier | customPlaceholder}}</b></p>
        </v-col>

        <v-col cols="12" md="6">
          <p class="mb-1 text-caption">Automated</p>
          <p><b>{{ getTelcoProvisioning.automated ? 'Yes' : 'No' }}</b></p>
        </v-col>
      </v-row>

    </v-card-text>

    <EditProvisioning :dialogOpen="editProvisioning" @close-dialog="editProvisioning=false" />
    <ProvisioningInfoDialog v-model="provisioningInfoOpen" />
  </v-card>
</template>

<script>
  import { mapGetters,mapActions } from 'vuex';
  import { mdiFormatListText,mdiEmailOutline  } from '@mdi/js';
  import { articleLinks } from '@/helpers/links';

  import EditProvisioning from './EditProvisioning';
  import BeehiveIcon from '@/components/Globals/BeehiveIcon';
  import ProvisioningInfoDialog from './ProvisioningInfoDialog.vue';

  export default {

    components: {EditProvisioning, BeehiveIcon, ProvisioningInfoDialog},

    data() {
      return {
        editProvisioning: false,
        emailIcon: mdiEmailOutline,
        queueIcon: mdiFormatListText,
        queue_url: process.env.VUE_APP_QUEUE_URL || `https://queues-bonline-testing.appspot.com/`,
        articleLinks,
        provisioningInfoOpen: false,
      }
    },

    computed: {
      ...mapGetters('products',['getCurrentProduct']),
      ...mapGetters('productTelco',['getTelcoProvisioning','getIsTelcoProvisioningLoading','getIsSendApptReminderLoading']),
      
      queueUrl(){
        return `${this.queue_url}telco-provisioning/actions/?product_id=${this.getCurrentProduct.id}`;
      },
    },

    methods: {
      ...mapActions('productTelco',['sendAppointmentReminder']),

      sendApptReminder() {
        if(confirm('Are you sure you want to send the appointment reminder email to the customer?')){
          this.sendAppointmentReminder(this.getCurrentProduct.id);
        }
      }
    },
    
  }
</script>

<style lang="scss" scoped>

</style>
